import React from 'react';
import { useAuth } from '../context/AuthContext';

const ComingSoonPage: React.FC = () => {
  const { logout } = useAuth();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center bg-gray-50 px-4">
      <div className="max-w-md mx-auto">
        {/* Logo or Icon */}
        <div className="mb-8">
          <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
        </div>
        
        {/* Main Message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Private Beta Access Required</h1>
        
        {/* Description */}
        <div className="space-y-4 mb-8">
          <p className="text-lg text-gray-600">
            The AskArc API Portal is currently in private beta.
          </p>
          <p className="text-base text-gray-500">
            We are gradually rolling out access to ensure the best experience for all users.
          </p>
        </div>
        
        {/* Contact Information */}
        <div className="bg-white rounded-lg p-6 shadow-sm mb-8">
          <h3 className="text-sm font-medium text-gray-900 mb-3">Request Early Access</h3>
          <p className="text-sm text-gray-600 mb-3">
            Interested in getting early access to the API portal?
          </p>
          <a
            href="mailto:support@fenxlabs.ai?subject=API Portal Beta Access Request"
            className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500"
          >
            Contact our team
            <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
        
        {/* Sign Out Button */}
        <button
          onClick={logout}
          className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default ComingSoonPage;
